// extracted by mini-css-extract-plugin
module.exports = {"box":"FJRecordingTiming_box__3zROW","title":"FJRecordingTiming_title__2ni7G","btn":"FJRecordingTiming_btn__2p8Ud","times":"FJRecordingTiming_times__1s8PG"};